module.exports = __webpack_public_path__ + "files/f14a552fb590bb07e65ed8cd8e64a0db.png";